import { useCallback, useState } from 'react';
import { GridRowSelectionModel } from '@mui/x-data-grid-pro';
import { PayRuleDB } from 'repository/timekeeper/@types/PayRuleModel';

export const usePayRulesTableState = () => {
    const [contextMenu, setContextMenu] = useState<{ mouseX: number; mouseY: number } | null>(null);
    const [selectedRow, setSelectedRow] = useState<PayRuleDB[]>([]);
    const [selected, setSelected] = useState<GridRowSelectionModel>([]);

    const cleanSelected = useCallback(() => {
        setSelectedRow([]);
        setSelected([]);
    }, []);

    return {
        contextMenu,
        setContextMenu,
        selectedRow,
        setSelectedRow,
        selected,
        setSelected,
        cleanSelected,
    };
};
